const Bodychildren = (props) => {
    return props.children;
}

export default Bodychildren;